import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on every route change (but leaves hash-anchor navigation alone —
// HomePage handles hash scrolling separately).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // leave hash-scroll to the page that owns it
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}
